import { RaceLeaderboardResults } from '../types.results.reignite';
import transformReigniteIntervalResults from './transformReigniteIntervalResults';

export default function transformReigniteRaceLeaderboardResults({
  data,
  eventId,
  isLinked,
}: {
  data: RaceLeaderboardResults;
  eventId: number;
  isLinked: boolean
}) {
  return data.intervals.map(i => ({
    bracketName: data.division.name, // for mobile rankings
    eventId,
    eventCourseId: data.race.id,
    interval: {
      intervalName: i.name,
      intervalResults: transformReigniteIntervalResults({
        division: data.division,
        interval: i,
        results: i.results,
      }),
    },
    thirdParySystemRaceId: isLinked,
    totalAthletes: data.division.totalAthletes,
  }));
}
